import { render, staticRenderFns } from "./FakeLocalNumberStepper.vue?vue&type=template&id=6a234134&scoped=true&"
import script from "./FakeLocalNumberStepper.vue?vue&type=script&lang=ts&"
export * from "./FakeLocalNumberStepper.vue?vue&type=script&lang=ts&"
import style0 from "./FakeLocalNumberStepper.vue?vue&type=style&index=0&id=6a234134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a234134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
